import { useEffect, useRef, useState } from 'react';

import { apiUrl, fetchJson } from '../../apiBase';
import { normalizeSortOrder } from './assessmentUiUtils';

const useMaarifLearningAreas = ({ bookId, notifyError }) => {
  const [learningAreas, setLearningAreas] = useState([]);
  const [loadingAreas, setLoadingAreas] = useState(false);
  const reqIdRef = useRef(0);

  useEffect(() => {
    setLearningAreas([]);

    if (!bookId) return;

    const rid = ++reqIdRef.current;
    const run = async () => {
      setLoadingAreas(true);
      try {
        const params = new URLSearchParams();
        params.set('maarif_id', String(bookId));
        const res = await fetchJson(apiUrl(`/admin/maarif/learning-areas?${params.toString()}`));
        if (rid !== reqIdRef.current) return;
        if (!res.ok) throw new Error('areas');
        const rows = await res.json();
        const items = (rows || [])
          .filter((r) => r && r.id != null)
          .map((r) => ({
            id: r.id,
            name: String(r.name || ''),
            sort_order: normalizeSortOrder(r.sort_order),
            is_active: !!r.is_active,
          }))
          .filter((r) => r.name)
          .sort(
            (a, b) =>
              a.sort_order - b.sort_order ||
              String(a.id).localeCompare(String(b.id), 'tr-TR') ||
              a.name.localeCompare(b.name, 'tr-TR')
          );
        setLearningAreas(items);
      } catch (e) {
        if (rid !== reqIdRef.current) return;
        notifyError && notifyError('Öğrenme alanları yüklenemedi');
        setLearningAreas([]);
      } finally {
        if (rid !== reqIdRef.current) return;
        setLoadingAreas(false);
      }
    };

    run();
  }, [bookId, notifyError]);

  return { learningAreas, loadingAreas };
};

export default useMaarifLearningAreas;
